export function countCharacters (input) {
    // Remove spaces from counting
    const text = input.replace(/\s+/g, "");

    if (typeof Intl !== "undefined" && Intl.Segmenter) {
        // Modern, accurate grapheme counting
        const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
        return [...segmenter.segment(text)].length;
    } else {
        // Fallback: count Unicode code points (emoji count correct, but no grapheme clusters)
        return [...text].length;
    }
};